import { Controller } from '@hotwired/stimulus'
import { createApp, h } from 'vue'
import App from '../apps/fast/App.vue'
import FaIcon from '@/apps/shared/components/fa-icon.vue'

export default class extends Controller {
  static values = {
    userSignedIn: Boolean,
    countries: Array,
    countryPriorities: Array
  }

  connect() {
    const self = this

    window.fastApp = createApp({
      data() {
        return {
          open: false,
          source: null,
          btnOpenClass: 'open-fast',
          locationOpenHash: 'open-fast',
          eventOpenName: 'openFast',
          userSignedIn: self.userSignedInValue,
          countryPriorities: self.countryPrioritiesValue,
          countries: self.countriesValue.reduce((acc, country) => {
            acc[country[1]] = country[0]
            return acc
          }, {})
        }
      },
      watch: {
        open(bool) {
          const classes = ['overflow-hidden', 'pr-[15px]', 'modal-open']
          if (bool) document.body.classList.add(...classes)
          else document.body.classList.remove(...classes)
        }
      },
      beforeMount() {
        Array.from(document.querySelectorAll(`.${this.btnOpenClass}`)).forEach(btn => {
          btn.addEventListener('click', event => this.openFast(event, btn))
        })

        Array.from(document.querySelectorAll('a')).forEach(el => {
          if (this.linkNotForFast(el)) return
          el.addEventListener('click', event => this.openFast(event, el))
        })

        document.addEventListener(this.eventOpenName, event => {
          this.userSignedIn = event.detail?.userSignedIn ?? this.userSignedIn
          this.source = this.extractSourceFrom(window.location, '!event')
          this.open = true
        })

        if (!this.locationOpenHashPresent()) {
          return
        }
        this.source = this.extractSourceFrom(window.location, '!anchor')
        this.open = true
      },
      methods: {
        openFast(event, tag) {
          event.preventDefault()
          this.source = this.extractSourceFrom(tag.getAttribute('href'))
          this.open = true
          return false
        },
        closeFast() {
          this.open = false

          if (!this.locationOpenHashPresent()) {
            return
          }
          window.location.hash = window.location.hash.replace(this.locationOpenHash, '')
        },
        locationOpenHashPresent() {
          return window.location.hash.includes(this.locationOpenHash)
        },
        linkNotForFast(tag) {
          return !tag.getAttribute('href')?.includes('/projects/new')
        },
        extractSourceFrom(location, suffix = null) {
          let source
          try {
            source = new URL(location).searchParams.get('source')
          } catch (_) {
            source = null
          }

          if (suffix === null) {
            return source
          } else if (source === null) {
            return suffix
          } else {
            return source + suffix
          }
        }
      },
      render() {
        if (!this.open) {
          return
        }

        return h(App, {
          source: this.source,
          userSignedIn: this.userSignedIn,
          onClose: this.closeFast
        })
      }
    }).component('FaIcon', FaIcon)

    window.fastApp.mount(this.element)
  }

  disconnect() {
    window.fastApp.unmount()
  }
}
